import { useDroppable } from "@dnd-kit/core";
import type { BlockType } from "../../types";
import { motion } from "motion/react";
import { ReactNode, useMemo } from "react";
import { cn } from "@babackapp/ui/lib/utils";
import { useEditorContext } from "../editor";

interface DroppableInsertButtonProps {
  section: "before" | "inside" | "after";
  index: number;
  onBlockDrop: (
    blockType: BlockType,
    section: "before" | "inside" | "after",
    index: number,
  ) => void;
  children: ReactNode;
}

export function DroppableInsertButton({
  section,
  index,
  onBlockDrop,
  children,
}: DroppableInsertButtonProps) {
  const { setNodeRef, isOver } = useDroppable({
    id: `insert-${section}-${index}`,
    data: {
      section,
      index,
      onBlockDrop,
    },
  });

  const { theme } = useEditorContext();


  const zoneColors = useMemo(() => {
    if (!theme)
      return {
        background: "#ffffff",
        icon: "#000000",
      };

    if (section === "inside") {
      return {
        background: theme.cardTextColor || "#ffffff",
        icon: theme.cardColor || "#000000",
      };
    } else {
      return {
        background: theme.backgroundTextColor || "#ffffff",
        icon: theme.backgroundColor || "#000000",
      };
    }
  }, [theme, section]);


  return (
    <div ref={setNodeRef} className={cn("relative")}>
      <div className="absolute inset-0 flex items-center justify-center z-50">
        <motion.div
          className="bg-muted w-full"
          style={{ height: 2, backgroundColor: zoneColors.background }}
          animate={{
            opacity: isOver ? 1 : 0,
          }}
        />
        <motion.div
          className="absolute px-2 py-0.5 rounded-full bg-background border border-muted text-[10px] font-medium text-muted-foreground"
          style={{ backgroundColor: zoneColors.background, borderColor: zoneColors.background, color: zoneColors.icon }}
          animate={{
            opacity: isOver ? 1 : 0,
            scale: isOver ? 1 : 0.8,
          }}
        >
          Ajouter ici
        </motion.div>
      </div>
      {children}
    </div>
  );
}
